import FormMeta from "./FormMeta";
import FormHero from "./FormHero";
import FormStats from "./FormStats";
import FormFaq from "./FormFaq";
import FormFooter from "./FormFooter";
import FormContact from "./FormContact";
import FormCaseStudies from "./FormCaseStudies";
import FormFeatures from "./FormFeatures";
import FormTeam from "./FormTeam";
import FormPricing from "./FormPricing";
import FormTestimonials from "./FormTestimonials";

export {
  FormMeta,
  FormHero,
  FormStats,
  FormFaq,
  FormFooter,
  FormContact,
  FormCaseStudies,
  FormFeatures,
  FormTeam,
  FormPricing,
  FormTestimonials,
};

// Simple forms map (used in renderSectionModal)
export const FORM_MAP = {
  meta: FormMeta,
  hero: FormHero,
  stats: FormStats,
  faq: FormFaq,
  footer: FormFooter,
  contact: FormContact,
};
